var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, PropSync } from 'vue-property-decorator';
import Checkbox from '@/components/Checkbox.vue';
let ExportationsUniqueDecisors = class ExportationsUniqueDecisors extends Vue {
    constructor() {
        super(...arguments);
        this.checkbox = false;
    }
    mounted() {
        this.checkbox = !!this.filters.unique_decisors_only;
    }
    onChange() {
        this.filters.unique_decisors_only = this.checkbox;
        this.$emit('updateCalculate');
    }
};
__decorate([
    PropSync('currentFilters', { default: () => { } })
], ExportationsUniqueDecisors.prototype, "filters", void 0);
ExportationsUniqueDecisors = __decorate([
    Component({
        name: 'ExportationsUniqueDecisors',
        components: {
            Checkbox,
        },
    })
], ExportationsUniqueDecisors);
export default ExportationsUniqueDecisors;
